import React, {useState} from 'react'
import BasicSearch from "components/BasicSearch";
import TemplateMembersElement from "./TemplateMembersElement";
import Tr from "translations/Translations";
import {makeStyles} from "@material-ui/core";
import PropTypes from "prop-types";

const useStyle = makeStyles(theme => ({
    search: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(2)
    }
}))

function TemplateMembersList(
    {
        groupId,
        members,
        coordinatorView,
        editable,
        validationSection,
        formIdPrefix
    }) {
    const classes = useStyle();
    const [search, setSearch] = useState({});

    return (<div className={classes.root}>
        {!coordinatorView && <BasicSearch className={classes.search} doSearch={setSearch} label={Tr('search_member')}/>}
        {
            members.map((x, i) => (<TemplateMembersElement
                key={x.memberId}
                index={i}
                groupId={groupId}
                member={x}
                search={search}
                coordinatorView={coordinatorView}
                editable={editable}
                validationSection={validationSection}
                formIdPrefix={formIdPrefix}
            />))
        }
    </div>)
}

TemplateMembersList.propTypes = {
    groupId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    members: PropTypes.array.isRequired,
    coordinatorView: PropTypes.bool.isRequired,
    editable: PropTypes.bool.isRequired
}

export default TemplateMembersList;